/**
 * AuthGrants API client.
 * STORY-1305 (Sprint 17 W1) — connects to /api/v1/auth-grants endpoints
 * mounted by STORY-1305a-prereq (apps/kgc-api/src/modules/auth-grants/).
 *
 * A típusok a `@kgc/api-contract` wire-szerződésből jönnek (workstream-ratify 2026-05-31) —
 * a korábbi kézi-duplikáció megszűnt, FE és BE ugyanazt a Zod-forrást fogyasztja.
 * A re-export megtartja a meglévő `@/api/auth-grants` import-pontot a fogyasztóknak.
 */

import type {
  AuthorizationGrant,
  AuthorizationGrantGranteeData,
  AuthorizationGrantStatus,
  AuthorizationGrantType,
  CreateOneTimeGrantInput,
  CreatePermanentGrantInput,
} from '@kgc/api-contract';
import { api } from './client';

export type {
  AuthorizationGrant,
  AuthorizationGrantGranteeData,
  AuthorizationGrantStatus,
  AuthorizationGrantType,
  CreateOneTimeGrantInput,
  CreatePermanentGrantInput,
};

export async function listActiveGrantsForGrantor(grantorPartnerId: string) {
  return api.get<{ data: AuthorizationGrant[] }>(
    `/auth-grants/active-for-grantor/${grantorPartnerId}`
  );
}

export async function createPermanentGrant(input: CreatePermanentGrantInput) {
  return api.post<{ data: AuthorizationGrant }>('/auth-grants/permanent', input);
}

export async function createOneTimeGrant(input: CreateOneTimeGrantInput) {
  return api.post<{ data: AuthorizationGrant }>('/auth-grants/one-time', input);
}
